export const MERCHANDISING_QUOTE_MIN_UNITS = 50;
export const MERCHANDISING_QUOTE_MAX_UNITS = 100000;

export const MERCHANDISING_QUOTE_QUERY_PARAMS = {
  product: 'producto',
  quantity: 'quantity',
  sizeId: 'sizeId',
  colorId: 'colorId',
} as const;

export const MERCHANDISING_CATEGORY_ID = 'a2e1c0de-0000-4000-8000-000000000002';
